/**
 * The two field shells every form in the application shares, so a text input
 * on the assignment modal is the same object as one on the task form.
 */
export const fieldClass =
  'w-full h-10 rounded-xl border border-line bg-canvas px-3 text-sm focus:outline-none focus:border-brand-500 focus:bg-panel';

export const areaClass =
  'w-full rounded-xl border border-line bg-canvas p-3 text-sm focus:outline-none focus:border-brand-500 focus:bg-panel';
